module.exports = __webpack_public_path__ + "static/media/gcdef_10064.a3507daa.ico";